import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { Reveal, RevealLineOnScroll } from "./Reveal";

const Chapter = ({ number, heading, body, kicker, id, children }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [50, -50]);

  return (
    <div
      ref={ref}
      id={id}
      data-testid={`manifesto-chapter-${number}`}
      className="max-w-[1400px] mx-auto px-6 md:px-10 pt-12 md:pt-16 pb-6 md:pb-8 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="grid md:grid-cols-12 gap-6 md:gap-10">
        <div className="md:col-span-4">
          <motion.p
            style={{ y }}
            className="font-display text-black/10 text-[80px] md:text-[120px] font-extrabold leading-none tracking-tighter"
          >
            {number}
          </motion.p>
        </div>
        <div className="md:col-span-8">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-4">
              {kicker}
            </p>
          </Reveal>
          {/* <h2 className="font-display text-black text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02]">
            {heading.map((line, i) => (
              <RevealLineOnScroll key={i} delay={i * 0.08}>
                {line}
              </RevealLineOnScroll>
            ))}
          </h2> */}
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-2xl text-lg md:text-xl text-black/60 leading-relaxed">
              {body}
            </p>
          </Reveal>
          {children}
        </div>
      </div>
    </div>
  );
};

export const Manifesto = () => {
  return (
    <section className="relative bg-white text-black">
      <Chapter
        number="01."
        kicker="Your wallet. Your money."
        heading={["You stay", "in control."]}
        body="Unlike traditional crypto cards, Straight never asks you to preload funds or hand over custody. Your stablecoins stay in your wallet until the moment you pay."
      />

      <Chapter
        id="self-custody"
        number="02."
        kicker="Built for self-custody"
        heading={["Your keys", "stay yours."]}
        body="Spend directly from the wallets you already use. No custodial balances. No top-ups."
      >
        {/* <Reveal delay={0.3}>
          <div className="mt-8 flex flex-wrap gap-3">
            {["No custodial balances", "No top-ups", "Your keys, your crypto"].map(
              (t) => (
                <span
                  key={t}
                  className="rounded-full border px-5 py-2.5 text-sm font-medium text-black/70"
                  style={{ borderColor: "var(--border-light)" }}
                >
                  {t}
                </span>
              )
            )}
          </div>
        </Reveal> */}
      </Chapter>
    </section>
  );
};
